// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__rAlI6","icon":"styles_icon__QB50h"};